// src/services/projects.ts
import { supabase } from "../lib/supabase";
import type { ID, Project } from "../types/domain";

export async function listProjects(companyId: ID) {
  const { data, error } = await supabase
    .from("projects")
    .select("*")
    .eq("company_id", companyId)
    .order("name", { ascending: true });

  return { data: (data as Project[]) ?? [], error };
}

export async function createProject(payload: Partial<Project> & { company_id: ID; name: string }) {
  const { data, error } = await supabase.from("projects").insert(payload).select().single();
  return { data: data as Project | null, error };
}

export async function updateProject(id: ID, patch: Partial<Project>) {
  const { data, error } = await supabase.from("projects").update(patch).eq("id", id).select().single();
  return { data: data as Project | null, error };
}

export async function deleteProject(id: ID) {
  const { error } = await supabase.from("projects").delete().eq("id", id);
  return { error };
}

export async function getProjectsWithoutCompany() {
  const { data, error } = await supabase
    .from("projects")
    .select("*")
    .is("company_id", null)
    .order("name", { ascending: true });

  return { data: (data as Project[]) ?? [], error };
}